import React from "react"
import { Row, Col } from 'antd';

export const SectionHeader = React.memo(({ title, description }) => {
    return (
        <div className="container-section-info">
            <Row align="middle" justify="center" type="flex" className="container-item">
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="container-info-web" style={{textAlign: 'center'}}>
                    {title}
                    {description}
                </Col>
            </Row>
        </div>
    )
})
